import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {serialize} from 'class-transformer';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';
import {Question} from 'shared/models/questions/question';
import {IQuestionsDetailsRepository} from './questions-details.repository.interface';

@Injectable()
export class QuestionsDetailsHttpRepository implements IQuestionsDetailsRepository {

  constructor(private http: Http) { }

  public getQuestion(id: string): Observable<Question> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.questions}/${id}`, options)
      .map((res: Response) => {
        return res.json();
      });
  }

  public saveQuestion(question: Question): Observable<Question> {
    const headers: Headers = new Headers({
      'Content-Type': 'application/json',
    });

    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
      headers: headers,
    });
    const body: string = serialize(question);

    return this.http.post(environment.questions, body, options)
      .map((res: Response) => {
        return res.json();
      });
  }

  public updateQuestion(question: Question): Observable<Question> {
    const headers: Headers = new Headers({
      'Content-Type': 'application/json',
    });

    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
      headers: headers,
    });
    const body: string = serialize(question);

    return this.http.put(`${environment.questions}/${question._id}`, body, options)
      .map((res: Response) => {
        return res.json();
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-details/repositories/questions-details.repository.http.ts